(function (app, ng) {

    function FieldStatusesModel(_, responseStatus, FieldStatus) {

        //Constructor Function
        function FieldStatusesModel(model) {
            //public properties
            this.fields = _.chain(model)
                .keys()
                .map(function(fieldName) {
                    return new FieldStatus(fieldName);
                })
                .value();
        }   

        //public methods
        FieldStatusesModel.prototype.addFieldStatus = function(fieldStatus) {
            this.fields.push(fieldStatus);
        };
        FieldStatusesModel.prototype.findFieldStatusByName = function (name) {
            return _.find(this.fields,
                function(fieldStatus) {
                    return fieldStatus.fieldName === name;
                });
        };
        FieldStatusesModel.prototype.removeFieldStatusByName = function (name) {
            _.remove(this.fields,
                function(fieldStatus) {
                    return fieldStatus.fieldName === name;
                });
        };
        FieldStatusesModel.prototype.succeedFieldStatusByName = function (name) {
            this.fields[_.findIndex(this.fields,
                function(fieldStatus) {
                    return fieldStatus.fieldName === name;
                })].succeed();

            this.fields = _.map(this.fields,
                function(fieldStatus) {
                    if (!fieldStatus.is(responseStatus.Nothing)&&
                        !fieldStatus.is(responseStatus.Saved) &&
                        !fieldStatus.is(responseStatus.Typing)) {
                        fieldStatus.succeed();
                    }
                    return fieldStatus;
                });
        };

        return FieldStatusesModel;

    }

    FieldStatusesModel.$inject = ["_", "responseStatus", "FieldStatus"];
    app.factory("FieldStatusesModel", FieldStatusesModel);

})(window.app, window.angular); //jshint ignore:line